var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import parseHTML from "./dom/funciones/parse_html";
import acordeon from "./aria/acordeon";
// Array of callbacks to be executed when consent changes
var pendientes = [];
// Array of callbacks to be executed when consent changes
var consentListeners = [];
window.addConsentListener = function (callback) {
    pendientes.forEach(function (consent) { return callback(consent); });
    consentListeners.push(callback);
};
var mostrarCookies = function () { return popup.classList.add('is-visible'); };
/**
 * Called when user grants/denies consent.
 * @param consent
 */
var onConsentChange = function (consent) {
    document.cookie = "cookie_consent=".concat(JSON.stringify(consent), ";path=/;max-age=31536000");
    if (consentListeners.length === 0) {
        pendientes.push(consent);
    }
    else {
        consentListeners.forEach(function (callback) { return callback(consent); });
    }
};
var popup = parseHTML("<div class=\"popup-cookies\" role=\"banner\">\n    <div class=\"inner\">\n        <div class=\"popup-cookies__texto\">\n            Utilizamos cookies propias y de terceros para mejorar nuestros servicios.\n            Si haces clic en ACEPTAR, consideramos que aceptas su uso.\n            Puedes obtener m\u00E1s informaci\u00F3n en la \n            <a href=\"/condiciones-de-uso/\" target=\"_blank\">Pol\u00EDtica de cookies</a>.\n        </div>\n        <div class=\"popup-cookies__botones\">\n            <button class=\"popup-cookies__rechazar\">\n                Rechazar\n            </button>\n            <button class=\"popup-cookies__configurar\">\n                Configurar\n            </button>\n            <button class=\"popup-cookies__aceptar\">\n                Aceptar\n            </button>\n        </div>\n    </div>\n</div>");
var ocultar = function () {
    popup.classList.remove('is-visible');
};
var creaConfiguracion = function (opciones, configuracion, onAceptar) {
    var popup = parseHTML("<div class=\"popup-cookies__configuracion\" role=\"dialog\">\n        <form class=\"inner\">\n            <div class=\"popup-cookies__configuracion__texto\">\n                ".concat(opciones.configuracion.mensaje, "\n            </div>\n\n            <div class=\"popup-cookies__configuracion__botones\">\n                <button class=\"popup-cookies__configuracion__guardar\" type=\"button\">\n                    ").concat(opciones.guardarConfiguracion, "\n                </button>\n                <button class=\"popup-cookies__configuracion__aceptar\" type=\"button\">\n                    ").concat(opciones.aceptarTodas, "\n                </button>\n            </div>\n\n            <div class=\"popup-cookies__configuracion__tipos\">\n            ").concat(opciones.configuracion.tipos.map(function (tipo, i) { return "\n                <div class=\"popup-cookies__configuracion__tipo\">\n                    <div class=\"popup-cookies__configuracion__tipo__nombre\">\n                        <div>\n                            <button aria-controls=\"cookies-".concat(i, "\" type=\"button\" aria-expanded=\"false\">").concat(tipo.nombre, "</button>\n                        </div>\n                        <div>\n                            ").concat(tipo.obligatorio ? opciones.siempreHabilitado : "<input type=\"checkbox\" name=\"".concat(tipo.consentimiento, "\" ").concat(configuracion[tipo.consentimiento] ? 'checked' : '', ">"), "\n                        </div>\n                    </div>\n                    <div class=\"popup-cookies__configuracion__tipo__descripcion\" id=\"cookies-").concat(i, "\" hidden>\n                        <div class=\"inner\">").concat(tipo.descripcion, "</div>\n                    </div>\n                </div>\n            "); }).join(''), "\n            </div>\n        </form>\n    </div>"));
    var form = popup.querySelector('form'), guardar = popup.querySelector('.popup-cookies__configuracion__guardar'), aceptar = popup.querySelector('.popup-cookies__configuracion__aceptar');
    acordeon(popup, false);
    guardar.addEventListener('click', function () {
        onAceptar(opciones.configuracion.tipos.filter(function (x) { return x.consentimiento; }).reduce(function (acc, tipo) {
            var _a;
            var input = form.querySelector('input[name="' + tipo.consentimiento + '"]');
            return (__assign(__assign({}, acc), (_a = {}, _a[tipo.consentimiento] = input ? input.checked : true, _a)));
        }, {}));
    });
    aceptar.addEventListener('click', function () {
        onAceptar(opciones.configuracion.tipos.filter(function (x) { return x.consentimiento; }).reduce(function (acc, tipo) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[tipo.consentimiento] = true, _a)));
        }, {}));
    });
    return popup;
};
var muestraValoresElegidos = function (opciones) {
    var contenedor = document.querySelector('.configuracion-cookies');
    if (!contenedor) {
        return;
    }
    var descripciones = Object.keys(opciones.configuracion.tipos).reduce(function (acc, key) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[opciones.configuracion.tipos[key].consentimiento] = opciones.configuracion.tipos[key].nombre, _a)));
    }, {});
    var configuracion = localStorage.configuracion ? JSON.parse(localStorage.configuracion) : {};
    var permitidas = Object.keys(configuracion).filter(function (key) { return configuracion[key]; });
    var rechazadas = Object.keys(configuracion).filter(function (key) { return !configuracion[key]; });
    if (permitidas.length === 0) {
        permitidas.push('functionality_storage');
    }
    var html = '<h2>' + opciones.tituloConsentimiento + '</h2><p> ' + opciones.textoEstado + ': ';
    var nombresPermitidas = permitidas.map(function (x) { return descripciones[x]; }).filter(function (x) { return x !== undefined; });
    var nombresRechazadas = rechazadas.map(function (x) { return descripciones[x]; }).filter(function (x) { return x !== undefined; });
    if (nombresPermitidas.length) {
        html += opciones.aceptadas + ': ' + nombresPermitidas.join(', ') + '. ';
    }
    if (nombresRechazadas.length) {
        html += opciones.rechazadas + ': ' + nombresRechazadas.join(', ') + '.';
    }
    html += '</p>';
    html += '<p><button class="coookies-mostrar">' + opciones.cambiarConfiguracion + '</button></p>';
    contenedor.innerHTML = html;
    var button = contenedor.querySelector('.coookies-mostrar');
    button.addEventListener('click', mostrarCookies);
};
var cookies = function (dataLayer, opciones) {
    var aceptar = popup.querySelector('.popup-cookies__aceptar'), rechazar = popup.querySelector('.popup-cookies__rechazar'), configurar = popup.querySelector('.popup-cookies__configurar'), texto = popup.querySelector('.popup-cookies__texto'), cambiaConfiguracion = function (configuracion) {
        localStorage.fechaDeConfiguracion = Date.now().toString();
        localStorage.configuracion = JSON.stringify(configuracion);
        onConsentChange(configuracion);
        ocultar();
        muestraValoresElegidos(opciones);
    }, configuracion = localStorage.configuracion ? JSON.parse(localStorage.configuracion) : {}, tipos = function (aceptado) { return Object.keys(opciones.configuracion.tipos).reduce(function (acc, key) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[opciones.configuracion.tipos[key].consentimiento] = aceptado, _a)));
    }, {}); }, fecha = parseInt(localStorage.getItem('fechaDeConfiguracion') || '0'), popupConfiguracion = creaConfiguracion(opciones, configuracion, function (configuracion) {
        cambiaConfiguracion(configuracion);
        popupConfiguracion.classList.remove('is-visible');
    }), aceptaTodo = function () { return cambiaConfiguracion(tipos(true)); }, rechazaTodo = function () { return cambiaConfiguracion(__assign(__assign({}, tipos(false)), { functionality_storage: true })); }, muestraConfiguracion = function () {
        document.documentElement.appendChild(popupConfiguracion);
        popupConfiguracion.classList.add('is-visible');
        popup.classList.remove('is-visible');
    };
    if (opciones) {
        texto.innerHTML = (opciones === null || opciones === void 0 ? void 0 : opciones.texto) || texto.innerHTML;
        aceptar.innerHTML = opciones.aceptar;
        rechazar.innerHTML = opciones.rechazar;
        configurar.innerHTML = opciones.configurar;
        if (opciones.bloquear) {
            popup.classList.add('popup-cookies--bloquear');
        }
        if (!opciones.mostrarRechazar) {
            rechazar.remove();
        }
    }
    aceptar.addEventListener('click', aceptaTodo);
    rechazar.addEventListener('click', rechazaTodo);
    configurar.addEventListener('click', muestraConfiguracion);
    // Si no se ha aceptado o rechazado, mostrar el popup
    document.documentElement.appendChild(popup);
    document.documentElement.appendChild(popupConfiguracion);
    if (document.querySelector('.configuracion-cookies')) {
        muestraValoresElegidos(opciones);
        return;
    }
    if (Object.keys(configuracion).length > 0) {
        onConsentChange(configuracion);
        return;
    }
    // Si hace menos de 6 meses que se configuró, no mostrar el popup
    if (Object.keys(configuracion).length > 0 && fecha > Date.now() - 15768000000) {
        return;
    }
    window.setTimeout(mostrarCookies);
};
export default cookies;
